import { useTranslation } from 'react-i18next';

import type { SeoIssueSeverity } from '@nucleus-commerce/api-client/admin';
import { Badge } from '@nucleus-commerce/ui/components/badge';
import { cn } from '@nucleus-commerce/ui/lib/utils';

const TONE: Record<SeoIssueSeverity, string> = {
  error: 'bg-destructive/10 text-destructive border-transparent dark:bg-destructive/20',
  warn: 'bg-warning/20 text-warning-foreground border-transparent dark:bg-warning/25',
  info: 'border-border text-muted-foreground',
};

export function SeverityBadge({
  severity,
  className,
}: {
  severity: SeoIssueSeverity;
  className?: string;
}) {
  const { t } = useTranslation('seo');
  return (
    <Badge variant="outline" className={cn(TONE[severity], className)}>
      {t(`severity.${severity}`)}
    </Badge>
  );
}
